export default __webpack_public_path__ + "static/media/menu26.149c222b.svg";